import { updateStore } from '../configuration/configuration-store';
export const getConsentPolicy = async () => window.consentPolicyManager.getCurrentConsentPolicy();
export const resetPolicy = () => window.consentPolicyManager.resetPolicy();
export const savePolicy = async _ref => {
  let {
    policy,
    successCallback,
    errorCallback
  } = _ref;
  function innerSuccessCallback() {
    updateStore({
      consentPolicy: policy,
      policySubmitted: true
    });
    successCallback();
  }
  window.consentPolicyManager.setConsentPolicy(policy, innerSuccessCallback, errorCallback);
};
//# sourceMappingURL=consent-policy-manager.js.map